import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';

@Component({
  selector: 'app-confirm-indentify',
  templateUrl: './confirm-indentify.component.html',
  styleUrls: ['./confirm-indentify.component.scss'],

})
export class ConfirmIndentifyComponent implements OnInit {
  checkCertificateType: boolean = false;
  isEnterpriseApplyVerifyVneId: string = '';
  constructor(
    public dialogRef: MatDialogRef<ConfirmIndentifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public message: Message,
    public commonService: CommonService,
    public dialog: MatDialog,
    private router: Router,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
    this.checkCertificateType = data.checkCertificateType;
    this.isEnterpriseApplyVerifyVneId = data.isEnterpriseApplyVerifyVneId;
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onClickBtnViewUpdate() {
    const id = localStorage.getItem('enterpriseId')
    if (this.data.tenantId && this.data.hashKey) {
      if (this.data.contractIdAndContractEnterpriseIdEncode) {
        this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.data.hashKey}/${this.data.tenantId}/${this.data.contractIdAndContractEnterpriseIdEncode}`], {
          queryParams: {
            type: 'onSign'
          }
        });
      } else {
        this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.data.hashKey}/${this.data.tenantId}`], {
          queryParams: {
            type: 'onSign'
          }
        });
      }
    } else {
      this.router.navigate([`/kyc-confirm-account/update-enterprise/${id}`], {
        queryParams: {
          type: 'onSign'
        }
      });
    }
    this.dialogRef.close('onSign')
  }

  onKyc() {
    const message = this.data.isUpdate ?
      this.commonService.format(this.message.getMessage('messages.ekyc_must_be_on_phone_after_update'))
      : this.commonService.format(this.message.getMessage('messages.ekyc_must_be_on_phone'))
    const dialogRe = this.dialog.open(AlertEkycComponent, {
      width: '600px',
      data: message,
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        console.log("close")
      }
    });
    this.dialogRef.close()
  }
  onVneid() {
    const id = localStorage.getItem('enterpriseId')
    if (this.data.tenantId && this.data.hashKey) {
      if (this.data.contractIdAndContractEnterpriseIdEncode) {
        this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.data.hashKey}/${this.data.tenantId}/${this.data.contractIdAndContractEnterpriseIdEncode}`], {
          queryParams: {
            type: 'vneid'
          }
        });
      } else {
        this.router.navigate([`/kyc-confirm-account/update-enterprise-anonymous/${id}/${this.data.hashKey}/${this.data.tenantId}`], {
          queryParams: {
            type: 'vneid'
          }
        });
      }
    } else {
      this.router.navigate([`/kyc-confirm-account/update-enterprise/${id}`], {
        queryParams: {
          type: 'vneid'
        }
      });
    }
    this.dialogRef.close('vneid')
  }


}
